export default __webpack_public_path__ + "static/media/feather_search.cf0eda48.svg";